<template>
  <v-app-bar clipped-right :absolute="true">
    <v-app-bar-nav-icon
      class="ml-1"
      @click.stop="drawer = !drawer"
    ></v-app-bar-nav-icon>
    <Breadcrumbs />
    <v-spacer />
    <v-menu close-on-click v-model="showInfoUser" offset-y>
      <template v-slot:activator="{ on }">
        <v-card-actions link v-on="on">
          <v-list-item-content>
            <v-list-item-title>{{
              $ls.get("userDetail") ? $ls.get("userDetail").email : ""
            }}</v-list-item-title>
          </v-list-item-content>
          <v-icon size="15" class="ml-2">{{
            !showInfoUser ? "fas fa-caret-down" : "fas fa-caret-up"
          }}</v-icon>
        </v-card-actions>
      </template>
      <v-list>
        <template v-for="item in menuRouter">
          <template v-if="item.name == 'User'">
            <v-list-item
              v-for="(itemChildren, index) in item.children"
              :key="index"
              :to="itemChildren.path"
            >
              <template>
                <v-list-item-icon>
                  <v-icon dense v-text="itemChildren.meta.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="itemChildren.meta.title"
                  ></v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </template>
        </template>
        <v-list-item @click="handleLogout">
          <v-list-item-icon>
            <v-icon dense>fas fa-sign-in-alt</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>ログアウト</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
import mixin from "@/mixin";

export default {
  name: "Header",
  mixins: [mixin.Cognito],
  store: ["drawer", "breadcrumbs"],
  props: {
    menuRouter: {
      type: Array,
    },
  },
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      showInfoUser: false,
    };
  },
};
</script>